import { Reducer } from "redux";

import { Template, TemplatesCount } from "@/Contracts/Templates";
import {
	TemplatesListActionTypes,
	TemplatesListActions
} from "@/Actions/TemplatesList";
import {
	CustomView,
	CustomViewResponse,
	CustomViewsMetadata
} from "@/Contracts/UI";

export interface TemplatesListState {
	readonly isLoading: boolean;
	readonly templateList: Template[];
	readonly templateCount: TemplatesCount | null;
	readonly viewList: CustomViewResponse | null;
	readonly currentActiveView: CustomView | null;
	readonly viewMetadata: CustomViewsMetadata | null;
	readonly isViewChanged: boolean;
}

export const initialTemplatesListState: TemplatesListState = {
	isLoading: false,
	templateList: [],
	templateCount: null,
	viewList: null,
	currentActiveView: null,
	viewMetadata: null,
	isViewChanged: false
};

export const TemplatesListReducer: Reducer<
	TemplatesListState,
	TemplatesListActions
> = (
	state: TemplatesListState = initialTemplatesListState,
	action: TemplatesListActions
): TemplatesListState => {
	switch (action.type) {
		case TemplatesListActionTypes.SHOW_TEMPLATES_LIST_LOADER:
			return { ...state, isLoading: true };

		case TemplatesListActionTypes.HIDE_TEMPLATES_LIST_LOADER:
			return { ...state, isLoading: false };

		case TemplatesListActionTypes.FETCH_TEMPLATES_LIST_REQUESTED:
			return { ...state, isLoading: true };

		case TemplatesListActionTypes.FETCH_TEMPLATES_LIST_FAILED:
			return { ...state, isLoading: false };

		case TemplatesListActionTypes.FETCH_TEMPLATES_LIST_SUCCESSFUL:
			return {
				...state,
				isLoading: false,
				templateList: action.templateList.data,
				templateCount:
					action.templateList.filtered_count_map ??
					state.templateCount
			};

		case TemplatesListActionTypes.FETCH_TEMPLATES_LIST_VIEWS_SUCCESSFUL:
			return { ...state, viewList: action.viewList };

		case TemplatesListActionTypes.FETCH_TEMPLATES_LIST_VIEW_METADATA_SUCCESSFUL:
			return { ...state, viewMetadata: action.metadata };

		case TemplatesListActionTypes.CREATE_TEMPLATES_LIST_VIEW_SUCCESSFUL:
			return {
				...state,
				currentActiveView: action.view,
				viewList: state.viewList
					? {
							...state.viewList,
							data: [...(state.viewList?.data ?? []), action.view]
					  }
					: state.viewList,
				isViewChanged: false
			};

		case TemplatesListActionTypes.UPDATE_TEMPLATES_LIST_VIEW_SUCCESSFUL:
			return {
				...state,
				currentActiveView: action.view,
				viewList: state.viewList
					? {
							...state.viewList,
							data: state.viewList?.data?.map(view =>
								view.id === action.view.id ? action.view : view
							)
					  }
					: state.viewList,
				isViewChanged: false
			};

		case TemplatesListActionTypes.DELETE_TEMPLATES_LIST_VIEW_SUCCESSFUL:
			return {
				...state,
				currentActiveView: action.initialView,
				viewList: state.viewList
					? {
							...state.viewList,
							data: state.viewList?.data?.filter(
								view => view.id !== action.deletedView.id
							)
					  }
					: state.viewList,
				isViewChanged: false
			};

		case TemplatesListActionTypes.UPDATE_TEMPLATES_LIST_CURRENT_ACTIVE_VIEW:
			return {
				...state,
				currentActiveView: action.currentActiveView,
				isViewChanged: action.isViewChanged
			};

		case TemplatesListActionTypes.RESET_TEMPLATES_LIST_CURRENT_ACTIVE_VIEW:
			return {
				...state,
				isLoading: false,
				currentActiveView: null,
				isViewChanged: false,
				viewList: null,
				viewMetadata: null,
				templateList: [],
				templateCount: null
			};

		default:
			return state;
	}
};
